import { render, staticRenderFns } from "./transaction-history.vue?vue&type=template&id=8932f754&"
import script from "./transaction-history.vue?vue&type=script&lang=js&"
export * from "./transaction-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports